import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);
[
  ...document.querySelectorAll("#courceProgram .dayResult > p:nth-child(2)"),
].map((el) => {
  return new SplitType(el, {
    types: "words",
  });
});

gsap
  .timeline({
    scrollTrigger: {
      trigger: "#courceProgram",
      start: "top 80%",
      end: "bottom 80%",
      scrub: 1,
    },
  })
  .from("#courceProgram .container > .title h2", {
    y: -30,
    opacity: 0,
  })
  .from(
    "#courceProgram .swiper-slide",
    {
      y: 30,
      opacity: 0,
      stagger: 0.05,
    },
    0.3
  )
  .from("#courceProgram .dayResult .word", {
    opacity: 0,
    y: 30,
    stagger: 0.01,
  });

gsap
  .timeline({
    scrollTrigger: {
      trigger: "#cta",
      start: "top 80%",
      end: "bottom 0%",
      scrub: 1,
    },
  })
  .from("#cta .title :where(h3, p)", {
    stagger: 0.1,
    y: 30,
    opacity: 0,
  })
  .to("#cta .title :where(h3, p)", { stagger: 0.1, y: 30 });

gsap
  .timeline({
    scrollTrigger: {
      trigger: "#reviews",
      start: "top 80%",
      end: "bottom 80%",
      scrub: 1,
    },
  })
  .from("#reviews .container > .title", {
    y: -30,
    opacity: 0,
  });
